// extracted by mini-css-extract-plugin
export default {"sortBy":"SortBy_sortBy__0uP0p","sortByDesktop":"SortBy_sortByDesktop__3vXlv","sortByMenuLabel":"SortBy_sortByMenuLabel__q79+d chip"};